import { SelectboxItem } from '@/common/utils/types';
import { ChartThemeType, SettingsMode } from '@/dashboard/shared/types/widgets.types';
import { ReferenceInfo } from '@/dashboard/features/widgetSettings/editModeWidgetSettings/components/common/referenceSettingOption/referenceSettingOption.setup';
import { UnitOverride } from '@/dashboard/features/chartDataHandler/domain/unit';
import { DecimalOptions } from '@/dashboard/features/widgetSettings/editModeWidgetSettings/components/common/decimalsPrecisionSelect.setup';
import type { QueryStatTimezoneOption } from '@/dashboard/features/widgetSettings/editModeWidgetSettings/components/common/queryStatTimezoneOption.setup';
import { DEFAULT_CHART_DATA } from '../../../../../shared/constants/chartData.constants';

export interface PieChartOption {
  displayName: string;
  displayValue: string;
  fieldNameList: (SelectboxItem & {
    dataType: 'Number' | 'String';
    dataAttribute?: string;
    unit?: string;
  })[];
  showLegend: boolean;
  markerInfo: {
    show: boolean;
    showTotal: boolean;
  };
  orderBy: 'DESC' | 'ASC';
  limitNum: 5 | 10 | 25 | 50 | 100;
  decimalOptions: DecimalOptions;
  chartTheme?: ChartThemeType;
  sortByFieldName?: string;
  referenceInfo?: ReferenceInfo;
  applyDefaultValue?: boolean;
  unitOverride?: UnitOverride;
  settingsMode?: SettingsMode;
  queryStatTimezone?: QueryStatTimezoneOption;
  useCountUnit?: boolean;
}

export const DEFAULT_PIE_CHART_OPTION: PieChartOption = {
  displayName: '',
  displayValue: '',
  fieldNameList: [],
  showLegend: true,
  markerInfo: {
    show: true,
    showTotal: true,
  },
  chartTheme: undefined,
  sortByFieldName: undefined,
  orderBy: DEFAULT_CHART_DATA.ORDER_BY,
  limitNum: 50,
  referenceInfo: undefined,
  decimalOptions: {
    use: false,
    decimalsPrecision: 3,
  },
  queryStatTimezone: {
    mode: 'account',
    timezone: undefined,
  },
  useCountUnit: true,
};
